import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { forwardRef, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IFileUploaderValue } from '~/components/organisms/fields/FileUploader';
import type { IContainerProps } from '~/components/utils/Container';
import { FormSection } from '~/components/atoms/FormSection';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';

export type IMarkdownEditorImageFormValues = {
  src?: string;
  title?: string;
  alt?: string;
  files: Array<IFileUploaderValue>;
};

export type IMarkdownEditorImageFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IMarkdownEditorImageFormValues>,
    'form' | 'children' | 'onSubmit'
  > & {
    defaultValues?: DefaultValues<IMarkdownEditorImageFormValues>;
    onSubmit?: SubmitHandler<IMarkdownEditorImageFormValues>;
    appId?: string;
  };

export const MarkdownEditorImageForm = forwardRef<
  HTMLFormElement,
  IMarkdownEditorImageFormProps
>(function MarkdownEditorImageForm(props, ref) {
  const { sx, defaultValues, onSubmit, appId, ...other } = props;
  const form = useForm<IMarkdownEditorImageFormValues>({
    defaultValues,
  });

  const isInitRef = useRef(false);
  useEffect(() => {
    if (!isInitRef.current) {
      isInitRef.current = true;
    }
  }, [form]);

  return (
    <ContentBlock.FormBody
      ref={ref}
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      {...other}
    >
      <FormSection>
        <FormFileUploader
          appId={appId}
          control={form.control}
          acceptTypes={['picture']}
          name="files"
          maxFiles={1}
          rules={{ required: true }}
        />
      </FormSection>
    </ContentBlock.FormBody>
  );
});
